var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33984 11.875C3.88672 11.3867 3.88672 10.5938 4.33984 10.1094L7.20625 7.24297C7.69453 6.75469 8.48555 6.75469 8.97383 7.24297L11.875 10.1094L14.2992 7.68516L12.6828 6.06875C12.2891 5.67188 12.5664 5 13.125 5H18.125C18.4688 5 18.75 5.28125 18.75 5.625V10.625C18.75 11.1453 18.1012 11.4852 17.6832 11.0668L16.0668 9.45039L12.7586 12.7586C12.5156 13.0039 12.1953 13.125 11.875 13.125C11.5547 13.125 11.2352 13.0029 10.9914 12.7588L8.125 9.89453L6.14062 11.875C5.65625 12.3633 4.86328 12.3633 4.33984 11.875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.75 16.25H2.5V2.46484C2.5 1.80977 1.94023 1.25 1.25 1.25C0.559766 1.25 0 1.80977 0 2.46484V17.5C0 18.1875 0.5625 18.75 1.25 18.75H18.75C19.4414 18.75 20 18.1914 20 17.5C20 16.8086 19.4414 16.25 18.75 16.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.1ee5a0883d932cf4d4d0e8843ee53d10.svg";
export { ForwardRef as ReactComponent };